import { UNTITLED_CONVERSATION } from '@gasbi/shared/common/components/AgentChat';
import { formatRelativeTime } from '@gasbi/shared/common/components/Chat/format';
import type { ConversationListItem } from '@gasbi/shared/common/features/agents';

import { TIME_LABELS } from '@/components/timeLabels';

import EditOutlinedIcon from '@mui/icons-material/EditOutlined';
import MoreHorizIcon from '@mui/icons-material/MoreHoriz';
import OpenInNewIcon from '@mui/icons-material/OpenInNew';
import {
  Dropdown,
  IconButton,
  ListDivider,
  ListItem,
  ListItemDecorator,
  Menu,
  MenuButton,
  MenuItem,
  Typography,
} from '@mui/joy';

type PanelMenuProps = {
  /** The panel's app, for «Історія розмов у …»; none outside an app. */
  appLabel?: string;
  /** The conversations started in this panel's app, newest first. */
  history: ConversationListItem[];
  selectedId: string | null;
  onNew: () => void;
  onOpen: (conversationId: string) => void;
};

/** The full page lists every conversation of the user, from any app (ADR-0004 §2.8). */
const openFullPage = () => window.open('/', '_blank', 'noopener');

/** «⋯» of the panel: a new conversation, the history of this app's panel, all conversations on the full page. */
export const PanelMenu = ({
  appLabel,
  history,
  selectedId,
  onNew,
  onOpen,
}: PanelMenuProps) => (
  <Dropdown>
    <MenuButton
      slots={{ root: IconButton }}
      slotProps={{
        root: {
          size: 'sm',
          variant: 'plain',
          color: 'neutral',
          'aria-label': 'Меню чату',
        },
      }}
    >
      <MoreHorizIcon />
    </MenuButton>
    <Menu
      size='sm'
      placement='bottom-end'
      sx={{ width: 300, maxHeight: 420, overflow: 'auto' }}
    >
      <MenuItem onClick={onNew}>
        <ListItemDecorator>
          <EditOutlinedIcon fontSize='small' />
        </ListItemDecorator>
        Нова розмова
      </MenuItem>
      <ListDivider />
      <ListItem>
        <Typography level='body-xs' textColor='neutral.500'>
          {appLabel ? `Історія розмов у ${appLabel}` : 'Історія розмов'}
        </Typography>
      </ListItem>
      {history.length === 0 && <MenuItem disabled>Розмов ще немає</MenuItem>}
      {history.map(item => (
        <MenuItem
          key={item.id}
          selected={item.id === selectedId}
          onClick={() => onOpen(item.id)}
        >
          <Typography level='body-sm' noWrap sx={{ flex: 1, minWidth: 0 }}>
            {item.title || UNTITLED_CONVERSATION}
          </Typography>
          <Typography level='body-xs' textColor='neutral.400' flexShrink={0}>
            {formatRelativeTime(item.updatedAt, TIME_LABELS)}
          </Typography>
        </MenuItem>
      ))}
      <ListDivider />
      <MenuItem onClick={openFullPage}>
        <ListItemDecorator>
          <OpenInNewIcon fontSize='small' />
        </ListItemDecorator>
        Усі розмови в Gasbi AI
      </MenuItem>
    </Menu>
  </Dropdown>
);
